// extracted by mini-css-extract-plugin
export default {"Container":"ModalFooter_Container__p9Seb"};